import { TYPE_STRING } from './input-types';

export const id = 'itemOption';
export const apiKey = 'ItemAttributeValue';
export const type = TYPE_STRING;

export const itemOption = {
  id,
  apiKey,
  type,
};
